import { Flex } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useMemo } from "react";

import { useInsuranceSla } from "../../api/hooks/riskFunnelDashboard/useInsuranceSla.ts";
import SectionTitle from "../../components/Section/SectionTitle/SectionTitle.tsx";
import Table from "../../components/Table/Table.tsx";
import { toCurrencyPrice } from "../../utils/number.ts";

const InsuranceSlaTable = () => {
  const [{ data, fetching, error }] = useInsuranceSla();
  const insuranceSla = data?.insuranceSla;

  const columns = [
    {
      accessor: "customerCount",
      title: "Number of Customer",
    },
    {
      accessor: "limitCount",
      title: "Number of Limit",
    },
    {
      accessor: "nominal",
      title: "Nominal",
    },
    {
      accessor: "slaDays",
      title: "SLA (Days)",
    },
  ];
  const rows = useMemo(() => {
    return [
      {
        ...insuranceSla,
        nominal: toCurrencyPrice(insuranceSla?.nominal),
      },
    ];
  }, [insuranceSla]);

  if (error) {
    notifications.show({
      message: "Something went wrong while trying to fetch Insurance SLA data",
      variant: "error",
    });
  }

  return (
    <Flex direction="column" gap={20}>
      <SectionTitle variant="golden">Insurance</SectionTitle>
      <Table
        columns={columns}
        rows={rows}
        minWidth="50%"
        mih={0}
        loading={fetching}
      />
    </Flex>
  );
};

export default InsuranceSlaTable;
